module.exports = __webpack_public_path__ + "img/ch09_01_店外橱窗.18475fd9.jpg";